var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQ(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 27,
    viewBox: "0 0 38 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1109 26.7605L27.6599 22.8131L25.0525 20.6041C26.501 18.5036 27.2977 15.9686 27.2977 13.325V13.2526C27.2977 6.04593 21.6845 0.21543 13.8622 0.21543C6.03996 0.21543 0.354313 6.11836 0.354313 13.325V13.3974C0.354313 20.6041 5.96753 26.4346 13.7898 26.4346C16.6145 26.4346 19.1857 25.6379 21.3224 24.2617L24.1109 26.7605ZM13.8622 21.2921C9.37167 21.2921 6.18481 17.6707 6.18481 13.325V13.2526C6.18481 8.90686 9.29924 5.35786 13.7898 5.35786C18.2804 5.35786 21.4672 8.97929 21.4672 13.325V13.3974C21.4672 14.6649 21.25 15.8238 20.7792 16.874L16.6145 13.1077L13.0655 17.0913L17.194 20.6041C16.2162 21.0386 15.0935 21.2921 13.8622 21.2921ZM31.4482 26H37.3149V20.2057H31.4482V26Z",
    fill: "url(#paint0_linear_511_1247)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_511_1247",
    x1: -2,
    y1: -9,
    x2: 41.342,
    y2: 33.6358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E3DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQ);
export default __webpack_public_path__ + "static/media/Q.5961a7c6f5483af4a6b1eaafa317df6b.svg";
export { ForwardRef as ReactComponent };